import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';


function Animation({
  // advId,
  companyName,
  creative_name,
  creative_type,
  subtype,
  flag,
  company,
  editdata,
  handleshow,
  handlesubmit,
  createdEdited
}) {
  const { preview, setPreview } = useContext(CreativeContext);

  const navigate = useNavigate();
  const [video, setVideo] = useState("");
  const [show, setShow] = useState(false);
  const [vidProgress, setVidProgress] = useState(0);
  const [progress, setProgress] = useState(0);
  const [videourl, setVideourl] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [image, setImage] = useState("");
  const videoChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].type === "video/mp4") {
        setShow(true);
        setImgurl("")
      }
      else {
        setShow(false)
      }
      setVideo(e.target.files[0]);
      setPreview({ ...preview, sub_type: "fullvideo_or_gif" });
    } else {
      if (flag === "edit") {
        setVideourl(editdata.video_urls);
        setPreview({ ...preview, video_urls: editdata.video_urls === null ? editdata.img_urls : editdata.video_urls });
      } else {
        setVidProgress(0)
        setVideourl("");
        setPreview({ ...preview, video_urls: "" });
      }
      setVidProgress(0)
      setVideourl("");
      if (editdata.video_urls?.split(".").pop() === "mp4") {
        setShow(true)
      } else {
        setShow(false)
      }
    }
  };

  // const [btnlink, setbtnLink] = useState(false);
  // const handleClick = () => {
  //   setbtnLink(!btnlink);
  // };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });


  const formData1 = new FormData();
  formData1.append("files", image);
  const imageUrl = async () => {
    try {
      let url = await api({
        url: `/upload/image`,
        method: "POST",
        responseType: "json",
        data: formData1,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        setImgurl(url.data.data);
        setPreview({ ...preview, img_urls: url.data.data });
      } else {
        setProgress(0)
        setValue("image", null);
        setImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  }
  const formData = new FormData();
  formData.append("files", video);
  const videoUrl = async () => {
    try {
      let url = await api({
        url: `/upload/gif`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setVidProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        if (url.data.data.split('.').pop() === "gif") {
          setImgurl("")
          setVideourl(url.data.data);
          setPreview({
            ...preview,
            video_urls: url.data.data,
          });
        } else {
          setVideourl(url.data.data);
          setPreview({
            ...preview,
            video_urls: url.data.data,
          });
        }
        setValue("videolink", "");
      } else {
        setVidProgress(0)
        setValue("video", "");
        setVideo("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    } else {
      if (flag === "edit") {
        setImgurl(editdata.img_urls);
        setPreview({ ...preview, img_urls: editdata.img_urls });
      } else {
        setProgress(0);
        setImgurl("");
        setPreview({ ...preview, img_urls: "" });
      }
    }
  };

  useEffect(() => {
    if (image) imageUrl();
  }, [image]);

  useEffect(() => {
    if (flag === "edit" && editdata.video_urls?.split('.').pop() === "mp4") {
      setShow(true)
    }
  }, [flag]);

  useEffect(() => {
    if (video) videoUrl();
  }, [video]);


  let watchcheck = watch("btnclick");
  if (flag === "edit")
    // setShow(true)
    watchcheck = watch(
      "btnclick",
      editdata.button_enabled === 1 ? true : false
    );
  useEffect(() => {
    if (watchcheck !== false) {
      setPreview({ ...preview, button_enabled: watchcheck });
    } else {
      setPreview({ ...preview, button_enabled: false });
    }
  }, [watchcheck]);

  let watchbtntext = watch("btntext");
  useEffect(() => {
    if (watchbtntext !== "")
      setPreview({ ...preview, button_text: watchbtntext });
    else setPreview({ ...preview, button_text: "" });
  }, [watchbtntext]);

  let watchbuttonLang = watch("buttonLang");
  useEffect(() => {
    setPreview({ ...preview, btn_text_lang: watchbuttonLang });
  }, [watchbuttonLang]);

  let watchbtnurl = watch("btnurl", false);
  useEffect(() => {
    if (watchbtnurl !== "") {
      setPreview({ ...preview, button_link: watchbtnurl });
    } else setPreview({ ...preview, button_link: "" });
  }, [watchbtnurl]);

  let watchbtntextclr = watch("btntextclr")
  useEffect(() => {

    if (watchbtntextclr !== "") {
      setPreview({ ...preview, button_enabled: watchcheck, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr });
    } else {
      setPreview({ ...preview, button_enabled: watchcheck, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: '', btn_text_bgclr: watchbtntextbgclr });
    }
  }, [watchbtntextclr]);

  let watchMute = watch("mute");
  let watchPlay = watch("play")
  let watchLoop = watch("loop")
  let watchMuteIcon = watch("enableMuteIcon", true);
  if(flag === "edit")
  {
    watchMute = watch('mute', editdata?.unmute === 1 ? true : false)
    watchPlay = watch('play', editdata?.video_controls?.playicon === 1  ? true : false)
    watchLoop = watch('loop', editdata?.video_controls?.loop === 1  ? true : false)
    watchMuteIcon = watch('enableMuteIcon', editdata?.video_controls.enableMuteIcon === 1 ? true : false)
  }
  let watchbtntextbgclr = watch("btntextbgclr")
  useEffect(() => {

    if (watchbtntextbgclr !== "") {
      setPreview({ ...preview, button_enabled: watchcheck, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr });
    } else {
      setPreview({ ...preview, button_enabled: watchcheck, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: '' });
    }
  }, [watchbtntextbgclr]);

  let watchvideolink = watch("videolink", "");
  useEffect(() => {
    if (watchvideolink !== "") {
      setPreview({ ...preview, video_urls: watchvideolink });
      setValue("video", "");
      setVideourl("");
      setImgurl("");
      setShow(true)
    } else {
      if (flag === "edit") {
        setPreview({ ...preview, video_urls: editdata.video_urls });
      }
      else {
        setPreview({ ...preview, video_urls: videourl })
      }
    }
  }, [watchvideolink]);



  useEffect(() => {
    if (flag === "edit") {
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        video_urls: editdata.img_urls?.split('.').pop() === "gif" ? editdata.img_urls : editdata.video_urls,
        img_urls: editdata.img_urls,
        button_enabled: editdata.button_enabled === 1 ? true : false,
        button_text: editdata.button_text,
        button_link: editdata.button_link,
        btn_text_lang: editdata.btn_text_lang,
        btn_text_clr: editdata.btn_text_clr,
        btn_text_bgclr: editdata.btn_text_bgclr
      });
    }
  }, [company]);


  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        video_url: videourl && videourl.split('.').pop() === "mp4" ? videourl : (data.videolink || null),
        img_url: imgurl ? imgurl : videourl,
        clickurl: data.clickurl,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        btnclick: data.btnclick,
        btntext: data.btntext,
        btnurl: data.btnurl,
        btn_text_lang: parseInt(data.buttonLang),
        btn_text_clr: data.btntextclr,
        btn_text_bgclr: data.btntextbgclr,
        mute: data.mute,
        enableMuteIcon: data.enableMuteIcon,
        play:data.play,
        loop:data.loop
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/image/animation`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);

          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_id: editdata.creative_id,
        creative_name: creative_name,
        // clickurl: data.clickurl,
        mute: data.mute,
        enableMuteIcon: data.enableMuteIcon,
        play:data.play,
        loop:data.loop,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      image !== "" ? (obj.img_url = videourl?.split('.').pop() === "mp4" ? imgurl : editdata.img_urls) : (obj.img_url = (videourl?.split('.').pop() === "mp4") ? editdata.img_urls : (videourl?.split('.').pop() === "gif" ? videourl : editdata.img_urls));
      video !== "" ? (obj.video_url = videourl ? videourl?.split('.').pop() === "mp4" ? videourl : (data.videolink || null) : editdata.video_urls) : (obj.video_url = editdata.video_urls);
      watchcheck === true ? (obj.btnclick = true) : (obj.btnclick = false);
      watchcheck === true ? (obj.clickurl = data.clickurl) :(obj.click_url = "");
      watchcheck === true ? (obj.btntext = data.btntext) : (obj.btntext = "");
      watchcheck === true ? (obj.btnurl = data.btnurl) : (obj.btnurl = "");
      watchcheck === true ? (obj.btn_text_lang = watchbuttonLang) : (obj.btn_text_lang = null);
      watchcheck === true ? (obj.btn_text_clr = data.btntextclr) : (obj.btntextclr = "");
      watchcheck === true ? (obj.btn_text_bgclr = data.btntextbgclr) : (obj.btntextbgclr = "");
      try {
        let res = await api({
          url: `/creatives/image/editanimation`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);

        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };
  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="col-12">
          <div className="mb-3">
            <label className="form-label">Upload video</label><br />
            <span>(Video duration must be below 1-min and size must be less than 25mb )</span><br />
            <span>(Gif accepted only with width less than height )</span>
            <input
              className="form-control mb-2"
              type="file"
              id="formFile"
              name="files"
              {...register("video", {
                required:
                  flag === "edit"
                    ? false
                    : watchvideolink === ""
                      ? true
                      : false,
                onChange: (e) => videoChange(e),
              })}
            />
            {errors.video && (
              <p className="text-red-600">Video/GIF is mandatory</p>
            )}
          </div>
          {vidProgress > 0 && vidProgress < 100 ? <SlProgressBar value={vidProgress}>{vidProgress}%</SlProgressBar>
            : videourl?.length ? (
              <span>{`${videourl}`}</span>
            ) : (
              flag === "edit" && editdata.video_urls ? <span>{`${editdata.video_urls}`}</span> : editdata.img_urls && <span>{`${editdata.img_urls}`}</span>
            )}
          <div className="mb-3">
            <label className="form-label">Video URL</label>
            <input
              className="form-control"
              type="text"
              {...register("videolink", {
                required: false,
                pattern: {
                  value:
                    /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/\S+|.+\.mp4$/,
                  message: "Enter a Valid .mp4 URL",
                },
              })}
            />
            {(watchvideolink.includes("youtube.com/") || watchvideolink.includes("youtu.be/")) && !watchvideolink.includes("/embed/") ? <p className="text-red-600">Enter a Valid Embed URL</p> : errors.videolink && (
              <p className="text-red-600">{errors.videolink.message}</p>
            )}
          </div>
          {(show || (editdata.video_urls?.split('.').pop() !== "gif") && show) &&
            <div className="mb-3">
              <label className="form-label">Thumbnail Image</label><br />
              <span>(Images accepted only with dimensions above 360x592 and aspect ration must be 0.61:1 )</span>
              <input
                className="form-control mb-2"
                type="file"
                id="formFile"
                name="files"
                {...register("image", {
                  required: flag === "edit" && editdata.img_urls?.split('.').pop() === "gif" ? true : false,
                  onChange: (e) => imageChange(e),
                })}
              />
              {errors.image && (
                <p className="text-red-600">Image is mandatory</p>
              )}
              {progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar>
                : imgurl !== "" ? (
                  <span>{`${imgurl}`}</span>
                ) : (
                  flag === "edit" && editdata.img_urls?.split('.').pop() !== "gif" && <span>{` ${editdata.img_urls}`}</span>
                )}
            </div>}

          <div className="row mb-3">

            <div className="col">
              <label className="form-label">Impression URL - Primary</label>
              <input
                type="text"
                className="form-control"
                name="impurl"
                defaultValue={
                  editdata.impression_tracking_url
                    ? editdata.impression_tracking_url.primary
                    : null
                }
                {...register("impurl", {
                  required: false,
                  pattern: {
                    value:
                      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                    message: "Enter a Valid URL",
                  },
                })}
              />
              {errors.impurl && (
                <p className="text-red-600">{errors.impurl.message}</p>
              )}
            </div>
            <div className="col">
              <label className="form-label">Impression URL - Secondary</label>
              <input
                type="text"
                className="form-control"
                defaultValue={
                  editdata.impression_tracking_url
                    ? editdata.impression_tracking_url.secondary
                    : null
                }
                {...register("impurl1", {
                  required: false,
                  pattern: {
                    value:
                      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                    message: "Enter a Valid URL",
                  },
                })}
              />
              {errors.impurl1 && (
                <p className="text-red-600">{errors.impurl1.message}</p>
              )}
            </div>
          </div>
          <section>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={watchcheck}
                // onClick={handleClick}
                {...register("btnclick")}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Enable Button Click
              </label>
            </div>
          
            {watchcheck && (
              <>
                 <div className="col">
                  <label className="form-label">Click URL</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url}
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                          /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                        message: "Enter a Valid Url",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_text}
                      {...register("btntext", { required: watchcheck })}
                    />
                    {errors.btntext && (
                      <p className="text-red-600">Button Text is mandatory</p>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text color
                    </label>
                    <input
                      type="color"
                      defaultValue={flag === "edit" ? editdata.btn_text_clr : "#000000"}
                      {...register("btntextclr", {
                        required: watchcheck, pattern: {
                          value: /^#(?!000000)[a-zA-z0-9]{6}/gm
                        }
                      })}
                    />
                    {errors.btntextclr && (
                      <p className="text-red-600">Button Text color is mandatory</p>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text background color
                    </label>
                    <input
                      type="color"
                      defaultValue={flag === "edit" ? editdata.btn_text_bgclr : "#ffffff"}
                      {...register("btntextbgclr", {
                        required: watchcheck, pattern: {
                          value: /^#(?!ffffff)[a-zA-z0-9]{6}/gm
                        }
                      })}
                    />
                    {errors.btntextbgclr && (
                      <p className="text-red-600">Button Text background color is mandatory</p>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Link
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_link}
                      {...register("btnurl", {
                        required: watchcheck,
                        pattern: {
                          value:
                            /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.btnurl?.type === "pattern" && (
                      <p className="text-red-600">{errors.btnurl.message}</p>
                    )}
                    {errors.btnurl
                      ? errors.btnurl?.type !== "pattern" && (
                        <p className="text-red-600">{"Button URL Mandatory"}</p>
                      )
                      : null}
                  </div>
                  <div className="col">
                    <label className="form-label">Button Lang</label>
                    <select
                      className="form-select"
                      type="text"
                      defaultValue={
                        flag === "edit"
                          ? editdata.btn_text_lang !== null
                            ? `${editdata.btn_text_lang}`
                            : "1"
                          : "1"
                      }
                      {...register("buttonLang", { required: true })}

                    >
                      <option value="1">Telugu</option>
                      <option value="7">Bengali</option>
                      <option value="3">Hindi</option>
                      <option value="6">Marathi</option>
                      <option value="2">Tamil</option>
                      <option value="4">Kannada</option>
                      <option value="5">Malayalam</option>
                      <option value="8">Gujarathi</option>
                      <option value="10">Oria</option>
                    </select>
                  </div>
                </div>
              </>)}
          </section>
          <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchMuteIcon}
                  {...register("enableMuteIcon", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Enable Mute icon
                </label>
              </div>
          <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={watchMute}
                        {...register("mute", { required: false })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        Unmute 
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={watchPlay}
                        {...register("play", { required: false })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                       Enable Play Icon
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={watchLoop}
                        {...register("loop", { required: false })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        Loop 
                      </label>
                    </div>

          <div className="my-3 text-end">
            <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) || (vidProgress > 0 && vidProgress < 100)}>
              Save Creative
            </button>
          </div>
        </section>
      </form>
    </div>
  );
}

export default Animation;
